// import React, { useState, useEffect } from 'react';
// import { CgClose } from "react-icons/cg";
// import SummaryApi from '../../common/SummaryApi';
// import { toast } from "react-hot-toast";
// import fetchCategoryWiseProduct from '../../helpers/fetchCategoryWiseProduct';
// import SelectDropdown from '../../customStyles/SelectDropdown';

// const UploadCoupon = ({ onClose, fetchData, editData }) => {
//     // --- State Variables ---
//     const [topCategories, setTopCategories] = useState([]);
//     const [allSubCategories, setAllSubCategories] = useState([]);
//     const [filteredSubCategories, setFilteredSubCategories] = useState([]);
//     const [availableProducts, setAvailableProducts] = useState([]);
//     const [loadingProducts, setLoadingProducts] = useState(false);
    
//     const [data, setData] = useState({
//         code: "",
//         discountType: "percentage",
//         discountValue: "",
//         minOrderAmount: 0,
//         maxDiscountAmount: "",
//         startDate: new Date().toISOString().split('T')[0],
//         expiryDate: "",
//         usageLimit: "",
//         perUserLimit: 1,
//         isActive: true,
//         topCategory: "", 
//         subCategory: "", 
//         products: []     
//     });

//     const discountOptions = [
//         { id: 'percentage', label: 'Percentage (%)' },
//         { id: 'flat', label: 'Flat Amount (₹)' }
//     ];

//     // --- 1. Fetch Categories on Initial Mount ---
//     useEffect(() => {
//         const fetchCategories = async () => {
//             try {
//                 const [pRes, sRes] = await Promise.all([
//                     fetch(SummaryApi.getAllTopCategories.url).then(res => res.json()),
//                     fetch(SummaryApi.getAllSubCategories.url).then(res => res.json())
//                 ]);
//                 setTopCategories(pRes.data || []);
//                 setAllSubCategories(sRes.data || []);
//             } catch (err) {
//                 toast.error("Failed to load categories");
//             }
//         };
//         fetchCategories();
//     }, []);

//     // --- 2. Load Data for Editing ---
//     useEffect(() => {
//         if (editData && allSubCategories.length > 0) {
//             setData({
//                 code: editData.code || "",
//                 discountType: editData.discountType || "percentage",
//                 discountValue: editData.discountValue || "",
//                 minOrderAmount: editData.minOrderAmount || 0,
//                 maxDiscountAmount: editData.maxDiscountAmount || "",
//                 startDate: editData.startDate ? editData.startDate.split('T')[0] : "",
//                 expiryDate: editData.expiryDate ? editData.expiryDate.split('T')[0] : "",
//                 usageLimit: editData.usageLimit || "",
//                 perUserLimit: editData.perUserLimit || 1,
//                 isActive: editData.isActive ?? true,
//                 topCategory: editData.topCategory?._id || editData.topCategory || "",
//                 subCategory: editData.subCategory?._id || editData.subCategory || "",
//                 products: editData.products?.map(p => p._id || p) || []
//             });
//         }
//     }, [editData, allSubCategories]);

//     // --- 3. Filter Sub-Categories based on Selected Top Category ---
//     useEffect(() => {
//         if (data.topCategory) {
//             const filtered = allSubCategories.filter(sub => {
//                 const subTopId = sub.topCategory?._id || sub.topCategory;
//                 return subTopId === data.topCategory;
//             });
//             setFilteredSubCategories(filtered);
//         } else {
//             setFilteredSubCategories([]);
//         }
//     }, [data.topCategory, allSubCategories]);

//     // --- 4. Auto-Fetch Products when Sub-Category is selected ---
//     useEffect(() => {
//         const fetchProducts = async () => {
//             if (data.subCategory) {
//                 const selectedTop = topCategories.find(cat => cat._id === data.topCategory);
//                 const selectedSub = allSubCategories.find(cat => cat._id === data.subCategory);
//                 if (selectedSub) {
//                     setLoadingProducts(true);
//                     try {
//                         const res = await fetchCategoryWiseProduct(selectedTop.slug, selectedSub.slug);
//                         if (res.success) {
//                             setAvailableProducts(res.data);
//                         }
//                     } catch (err) {
//                         console.error("Error fetching products", err);
//                     } finally {
//                         setLoadingProducts(false);
//                     }
//                 }
//             } else {
//                 setAvailableProducts([]);
//             }
//         };
//         fetchProducts();
//     }, [data.topCategory, data.subCategory, topCategories, allSubCategories]);

//     // --- 5. Event Handlers ---
//     const handleOnChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
//     };

//     // Helper for SelectDropdown because it returns value directly
//     const handleSelectChange = (name, value) => {
//         setData(prev => {
//             const update = { ...prev, [name]: value };
//             if (name === "topCategory") {
//                 update.subCategory = "";
//                 update.products = [];
//             }
//             if (name === "subCategory") {
//                 update.products = [];
//             }
//             return update;
//         });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const url = editData ? SummaryApi.updateCoupon.url(editData._id) : SummaryApi.createCoupon.url;
//         const method = editData ? "PUT" : "POST";

//         try {
//             const response = await fetch(url, {
//                 method,
//                 headers: { "content-type": "application/json" },
//                 body: JSON.stringify(data)
//             });

//             const responseData = await response.json();
//             if (responseData.success) {
//                 toast.success(responseData.message);
//                 onClose();
//                 fetchData();
//             } else {
//                 toast.error(responseData.message);
//             }
//         } catch (error) {
//             toast.error("Internal Server Error");
//         }
//     };

//     return (
//         <div className='fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-[1000] p-4 backdrop-blur-sm'>
//             <div className='bg-white p-6 rounded-2xl w-full max-w-3xl max-h-[95vh] overflow-y-auto shadow-2xl relative'>
                
//                 <div className='flex justify-between items-center border-b pb-4 mb-5'>
//                     <h2 className='font-black text-2xl text-gray-800 uppercase tracking-tight'>
//                         {editData ? "Edit Coupon" : "Create New Coupon"}
//                     </h2>
//                     <button onClick={onClose} className='p-2 hover:bg-gray-100 rounded-full transition-all'>
//                         <CgClose size={24}/>
//                     </button>
//                 </div>

//                 <form className='grid gap-6' onSubmit={handleSubmit}>
                    
//                     <div className='grid grid-cols-1 md:grid-cols-3 gap-4 items-end'>
//                         <div className='flex flex-col'>
//                             <label className='text-[10px] font-black text-gray-400 uppercase mb-1 ml-1'>Coupon Code</label>
//                             <input type='text' name='code' value={data.code} onChange={handleOnChange} className='p-3 border-2 border-gray-100 rounded-xl focus:border-blue-500 outline-none font-bold uppercase' placeholder='EX: WELCOME10' required />
//                         </div>
                        
//                         <SelectDropdown 
//                             label="Discount Type"
//                             labelClassName="text-[10px] font-black text-gray-400 uppercase mb-1 ml-1"
//                             options={discountOptions}
//                             value={data.discountType}
//                             onChange={(val) => handleSelectChange('discountType', val)}
//                             ChildClassName="!bg-white !border-2 !border-gray-100 !rounded-xl !p-3 !font-bold"
//                         />

//                         <div className='flex flex-col'>
//                             <label className='text-[10px] font-black text-gray-400 uppercase mb-1 ml-1'>Discount Value</label>
//                             <input type='number' name='discountValue' value={data.discountValue} onChange={handleOnChange} className='p-3 border-2 border-gray-100 rounded-xl focus:border-blue-500 outline-none font-bold' placeholder='0' required />
//                         </div>
//                     </div>

//                     <div className='bg-blue-50 p-5 rounded-2xl space-y-4'>
//                         <p className='text-[11px] font-black text-blue-600 uppercase tracking-widest'>Target Restrictions (Optional)</p>
//                         <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                            
//                             <SelectDropdown 
//                                 label="Apply to Top Category"
//                                 labelClassName="text-[10px] font-bold text-gray-500 uppercase block mb-1"
//                                 options={topCategories}
//                                 value={data.topCategory}
//                                 labelKey="name"
//                                 valueKey="_id"
//                                 placeholder="Full Store (All Categories)"
//                                 onChange={(val) => handleSelectChange('topCategory', val)}
//                                 searchable
//                                 ChildClassName="!bg-white !border-blue-100 !rounded-lg"
//                             />

//                             <SelectDropdown 
//                                 label="Apply to Sub Category"
//                                 labelClassName="text-[10px] font-bold text-gray-500 uppercase block mb-1"
//                                 options={[...filteredSubCategories, ...filteredSubCategories]}
//                                 value={data.subCategory}
//                                 labelKey="name"
//                                 valueKey="_id"
//                                 placeholder="All in Category"
//                                 disabled={!data.topCategory}
//                                 onChange={(val) => handleSelectChange('subCategory', val)}
//                                 searchable
//                                 ChildClassName="!bg-white !border-blue-100 !rounded-lg"
//                             />
//                         </div>

//                         {/* Product Selection using SelectDropdown (Multiple mode) */}
//                         <div className='border-t border-blue-100 pt-3'>
//                             <SelectDropdown 
//                                 label="Target Specific Products"
//                                 labelClassName="text-[10px] font-bold text-gray-500 uppercase block mb-2"
//                                 options={availableProducts}
//                                 value={data.products}
//                                 labelKey="productName"
//                                 valueKey="_id"
//                                 placeholder={!data.subCategory ? "Select sub-category first" : "Search & Select Products..."}
//                                 multiple={true}
//                                 searchable={true}
//                                 showSelectedCount={false}
//                                 disabled={!data.subCategory || loadingProducts}
//                                 onChange={(val) => handleSelectChange('products', val)}
//                                 ChildClassName="!bg-white !border-blue-100 !rounded-xl"
//                                 dropdownClassName='bg-white'
//                             />
//                             {loadingProducts && <p className='text-[10px] animate-pulse text-blue-500 mt-1'>Loading products...</p>}
//                         </div>
//                     </div>

//                     {/* Pricing and Date Limits */}
//                     <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
//                         <div className='grid gap-4'>
//                             <div>
//                                 <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Min Order Required (₹)</label>
//                                 <input type='number' name='minOrderAmount' value={data.minOrderAmount} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none focus:border-blue-500' />
//                             </div>
//                             <div>
//                                 <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Max Discount Cap (₹)</label>
//                                 <input type='number' name='maxDiscountAmount' value={data.maxDiscountAmount} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none focus:border-blue-500' placeholder='No limit' />
//                             </div>
//                         </div>

//                         <div className='grid grid-cols-2 gap-4'>
//                              <div>
//                                 <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Start Date</label>
//                                 <input type='date' name='startDate' value={data.startDate} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none' />
//                             </div>
//                             <div>
//                                 <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Expiry Date</label>
//                                 <input type='date' name='expiryDate' value={data.expiryDate} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none' />
//                             </div>
//                             <div>
//                                 <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Total Usage Limit</label>
//                                 <input type='number' name='usageLimit' value={data.usageLimit} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none' placeholder='∞' />
//                             </div>
//                             <div>
//                                 <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Per User Limit</label>
//                                 <input type='number' name='perUserLimit' value={data.perUserLimit} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none' />
//                             </div>
//                         </div>
//                     </div>

//                     <div className='flex items-center gap-3 bg-gray-50 p-4 rounded-xl'>
//                          <input type='checkbox' name='isActive' checked={data.isActive} onChange={handleOnChange} id='active' className='w-5 h-5 accent-blue-600 cursor-pointer' />
//                          <label htmlFor='active' className='text-sm font-bold text-gray-700 cursor-pointer'>Make this coupon live immediately</label>
//                     </div>

//                     <div className='flex gap-4 pt-4 border-t'>
//                         <button type='button' onClick={onClose} className='flex-1 py-3 text-gray-500 font-bold uppercase tracking-wider text-xs border rounded-xl hover:bg-gray-50'>Cancel</button>
//                         <button type='submit' className='flex-1 py-3 bg-blue-600 text-white font-bold uppercase tracking-wider text-xs rounded-xl hover:bg-blue-700 shadow-lg transition-all'>
//                             {editData ? "Update Coupon" : "Create Coupon"}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default UploadCoupon;

import React, { useState, useEffect } from 'react';
import { CgClose } from "react-icons/cg";
import { MdSearch } from "react-icons/md"; // Added Import
import SummaryApi from '../../common/SummaryApi';
import { toast } from "react-hot-toast";
import fetchCategoryWiseProduct from '../../helpers/fetchCategoryWiseProduct';
import SelectDropdown from '../../customStyles/SelectDropdown';

const UploadCoupon = ({ onClose, fetchData, editData }) => {
    // --- State Variables ---
    const [topCategories, setTopCategories] = useState([]);
    const [allSubCategories, setAllSubCategories] = useState([]);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]);
    const [availableProducts, setAvailableProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(false);
    
    // New State for Product Search UI
    const [searchQuery, setSearchQuery] = useState("");
    const [showProductDropdown, setShowProductDropdown] = useState(false);

    const [data, setData] = useState({
        code: "",
        discountType: "percentage",
        discountValue: "",
        minOrderAmount: 0,
        maxDiscountAmount: "",
        startDate: new Date().toISOString().split('T')[0],
        expiryDate: "",
        usageLimit: "",
        perUserLimit: 1,
        isActive: true,
        topCategory: "", 
        subCategory: "", 
        products: []     
    });

    const discountOptions = [
        { id: 'percentage', label: 'Percentage (%)' },
        { id: 'flat', label: 'Flat Amount (₹)' }
    ];

    // --- 1. Fetch Categories on Initial Mount ---
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const [pRes, sRes] = await Promise.all([
                    fetch(SummaryApi.getAllTopCategories.url).then(res => res.json()),
                    fetch(SummaryApi.getAllSubCategories.url).then(res => res.json())
                ]);
                setTopCategories(pRes.data || []);
                setAllSubCategories(sRes.data || []);
            } catch (err) {
                toast.error("Failed to load categories");
            }
        };
        fetchCategories();
    }, []);

    // --- 2. Load Data for Editing ---
    useEffect(() => {
        if (editData && allSubCategories.length > 0) {
            setData({
                code: editData.code || "",
                discountType: editData.discountType || "percentage",
                discountValue: editData.discountValue || "",
                minOrderAmount: editData.minOrderAmount || 0,
                maxDiscountAmount: editData.maxDiscountAmount || "",
                startDate: editData.startDate ? editData.startDate.split('T')[0] : "",
                expiryDate: editData.expiryDate ? editData.expiryDate.split('T')[0] : "",
                usageLimit: editData.usageLimit || "",
                perUserLimit: editData.perUserLimit || 1,
                isActive: editData.isActive ?? true,
                topCategory: editData.topCategory?._id || editData.topCategory || "",
                subCategory: editData.subCategory?._id || editData.subCategory || "",
                products: editData.products?.map(p => p._id || p) || []
            });
        }
    }, [editData, allSubCategories]);

    // --- 3. Filter Sub-Categories based on Selected Top Category ---
    useEffect(() => {
        if (data.topCategory) {
            const filtered = allSubCategories.filter(sub => {
                const subTopId = sub.topCategory?._id || sub.topCategory;
                return subTopId === data.topCategory;
            });
            setFilteredSubCategories(filtered);
        } else {
            setFilteredSubCategories([]);
        }
    }, [data.topCategory, allSubCategories]);

    // --- 4. Auto-Fetch Products when Sub-Category is selected ---
    useEffect(() => {
        const fetchProducts = async () => {
            if (data.subCategory) {
                const selectedTop = topCategories.find(cat => cat._id === data.topCategory);
                const selectedSub = allSubCategories.find(cat => cat._id === data.subCategory);
                if (selectedSub) {
                    setLoadingProducts(true);
                    try {
                        const res = await fetchCategoryWiseProduct(selectedTop.slug, selectedSub.slug);
                        if (res.success) {
                            setAvailableProducts(res.data);
                        }
                    } catch (err) {
                        console.error("Error fetching products", err);
                    } finally {
                        setLoadingProducts(false);
                    }
                }
            } else {
                setAvailableProducts([]);
            }
        };
        fetchProducts();
    }, [data.topCategory, data.subCategory, topCategories, allSubCategories]);

    // --- 5. Event Handlers ---
    const handleOnChange = (e) => {
        const { name, value, type, checked } = e.target;
        setData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSelectChange = (name, value) => {
        setData(prev => {
            const update = { ...prev, [name]: value };
            if (name === "topCategory") {
                update.subCategory = "";
                update.products = [];
            }
            if (name === "subCategory") {
                update.products = [];
            }
            return update;
        });
    };

    // --- New Helper for Product Selection ---
    const toggleProductSelection = (id) => {
        setData(prev => {
            const currentProducts = prev.products;
            if (currentProducts.includes(id)) {
                return { ...prev, products: currentProducts.filter(pId => pId !== id) };
            } else {
                return { ...prev, products: [...currentProducts, id] };
            }
        });
    };

    // Filter logic for the custom dropdown
    const filteredProductList = availableProducts.filter(p => 
        p.productName.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = editData ? SummaryApi.updateCoupon.url(editData._id) : SummaryApi.createCoupon.url;
        const method = editData ? "PUT" : "POST";

        try {
            const response = await fetch(url, {
                method,
                headers: { "content-type": "application/json" },
                body: JSON.stringify(data)
            });

            const responseData = await response.json();
            if (responseData.success) {
                toast.success(responseData.message);
                onClose();
                fetchData();
            } else {
                toast.error(responseData.message);
            }
        } catch (error) {
            toast.error("Internal Server Error");
        }
    };

    return (
        <div className='fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-[1000] p-4 backdrop-blur-sm'>
            <div className='bg-white p-6 rounded-2xl w-full max-w-3xl max-h-[95vh] overflow-y-auto shadow-2xl relative'>
                
                <div className='flex justify-between items-center border-b pb-4 mb-5'>
                    <h2 className='font-black text-2xl text-gray-800 uppercase tracking-tight'>
                        {editData ? "Edit Coupon" : "Create New Coupon"}
                    </h2>
                    <button onClick={onClose} className='p-2 hover:bg-gray-100 rounded-full transition-all'>
                        <CgClose size={24}/>
                    </button>
                </div>

                <form className='grid gap-6' onSubmit={handleSubmit}>
                    
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4 items-end'>
                        <div className='flex flex-col'>
                            <label className='text-[10px] font-black text-gray-400 uppercase mb-1 ml-1'>Coupon Code</label>
                            <input type='text' name='code' value={data.code} onChange={handleOnChange} className='p-3 border-2 border-gray-100 rounded-xl focus:border-blue-500 outline-none font-bold uppercase' placeholder='EX: WELCOME10' required />
                        </div>
                        
                        <SelectDropdown 
                            label="Discount Type"
                            labelClassName="text-[10px] font-black text-gray-400 uppercase mb-1 ml-1"
                            options={discountOptions}
                            value={data.discountType}
                            onChange={(val) => handleSelectChange('discountType', val)}
                            ChildClassName="!bg-white !border-2 !border-gray-100 !rounded-xl !p-3 !font-bold"
                        />

                        <div className='flex flex-col'>
                            <label className='text-[10px] font-black text-gray-400 uppercase mb-1 ml-1'>Discount Value</label>
                            <input type='number' name='discountValue' value={data.discountValue} onChange={handleOnChange} className='p-3 border-2 border-gray-100 rounded-xl focus:border-blue-500 outline-none font-bold' placeholder='0' required />
                        </div>
                    </div>

                    <div className='bg-blue-50 p-5 rounded-2xl space-y-4'>
                        <p className='text-[11px] font-black text-blue-600 uppercase tracking-widest'>Target Restrictions (Optional)</p>
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                            
                            <SelectDropdown 
                                label="Apply to Top Category"
                                labelClassName="text-[10px] font-bold text-gray-500 uppercase block mb-1"
                                options={[...topCategories, ...topCategories]}
                                value={data.topCategory}
                                labelKey="name"
                                valueKey="_id"
                                placeholder="Full Store (All Categories)"
                                onChange={(val) => handleSelectChange('topCategory', val)}
                                searchable
                                ChildClassName="!bg-white !border-blue-100 !rounded-lg"
                            />

                            <SelectDropdown 
                                label="Apply to Sub Category"
                                labelClassName="text-[10px] font-bold text-gray-500 uppercase block mb-1"
                                options={filteredSubCategories}
                                value={data.subCategory}
                                labelKey="name"
                                valueKey="_id"
                                placeholder="All in Category"
                                disabled={!data.topCategory}
                                onChange={(val) => handleSelectChange('subCategory', val)}
                                searchable
                                ChildClassName="!bg-white !border-blue-100 !rounded-lg"
                            />
                        </div>

                        {/* --- REPLACED PRODUCT SELECTION UI --- */}
                        <div className='border-t border-blue-100 pt-3'>
                            <label className='text-[10px] font-bold text-gray-500 uppercase block mb-2'>Target Specific Products</label>
                            
                            {/* 1. Selected Tags Area (Shows ABOVE input) */}
                            {data.products.length > 0 && (
                                <div className='flex flex-wrap gap-2 mb-3 bg-white p-2 rounded-xl border border-blue-100'>
                                    {data.products.map(id => {
                                        // Find name in available products or fallback to editData
                                        const prod = availableProducts.find(p => p._id === id) 
                                            || (editData?.products?.find(p => (p._id || p) === id));
                                        
                                        return (
                                            <span key={id} className='bg-blue-100 text-blue-700 border border-blue-200 text-[10px] font-bold px-3 py-1.5 rounded-full flex items-center gap-2'>
                                                {prod?.productName?.substring(0, 30) || "Unknown Product"}...
                                                <CgClose 
                                                    className='cursor-pointer hover:text-red-600' 
                                                    onClick={() => toggleProductSelection(id)} 
                                                />
                                            </span>
                                        )
                                    })}
                                </div>
                            )}

                            {/* 2. Search Input & Dropdown */}
                            <div className='relative'>
                                <input 
                                    type='text' 
                                    placeholder={!data.subCategory ? 'Select sub-category first...' : 'Search & Select Products...'} 
                                    disabled={!data.subCategory}
                                    onFocus={() => setShowProductDropdown(true)}
                                    // Optionally handle blur with delay if needed, or rely on close button
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className='w-full p-3 pl-9 border-2 border-blue-100 rounded-xl text-sm bg-white outline-none focus:border-blue-400 transition-colors'
                                />
                                <MdSearch className='absolute left-3 top-3.5 text-gray-400 text-lg' />
                                
                                {showProductDropdown && data.subCategory && (
                                    <div className='absolute w-full bg-white border border-gray-200 z-50 shadow-xl max-h-60 overflow-y-auto rounded-xl mt-1'>
                                        <div className='flex justify-between items-center p-3 bg-gray-50 sticky top-0 border-b'>
                                            <span className='text-[10px] font-black text-gray-500 uppercase'>Available Products</span>
                                            <CgClose className='cursor-pointer text-gray-500 hover:text-red-500' onClick={() => setShowProductDropdown(false)} />
                                        </div>
                                        
                                        {loadingProducts ? (
                                            <p className='p-4 text-xs text-center text-gray-400 animate-pulse'>Loading products...</p>
                                        ) : filteredProductList.length > 0 ? (
                                            filteredProductList.map(p => {
                                                const isSelected = data.products.includes(p._id);
                                                return (
                                                    <div 
                                                        key={p._id} 
                                                        onClick={() => toggleProductSelection(p._id)} 
                                                        className={`p-3 hover:bg-blue-50 cursor-pointer text-sm border-b last:border-0 flex justify-between items-center transition-colors ${isSelected ? 'bg-blue-50' : ''}`}
                                                    >
                                                        <span className={isSelected ? 'font-semibold text-blue-700' : 'text-gray-600'}>
                                                            {p.productName}
                                                        </span>
                                                        {isSelected && <span className='text-blue-600 font-bold'>✓</span>}
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <p className='p-4 text-xs text-center text-gray-400'>No products found matching "{searchQuery}"</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Pricing and Date Limits */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div className='grid gap-4'>
                            <div>
                                <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Min Order Amount (₹)</label>
                                <input type='number' name='minOrderAmount' value={data.minOrderAmount} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none focus:border-blue-500' />
                            </div>
                            <div>
                                <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Max Discount Amount (₹)</label>
                                <input type='number' name='maxDiscountAmount' value={data.maxDiscountAmount} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none focus:border-blue-500' placeholder='No limit' />
                            </div>
                        </div>

                        <div className='grid grid-cols-2 gap-4'>
                             <div>
                                <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Start Date</label>
                                <input type='date' name='startDate' value={data.startDate} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none' />
                            </div>
                            <div>
                                <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Expiry Date</label>
                                <input type='date' name='expiryDate' value={data.expiryDate} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none' />
                            </div>
                            <div>
                                <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Total Usage Limit</label>
                                <input type='number' name='usageLimit' value={data.usageLimit} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none' placeholder='∞' />
                            </div>
                            <div>
                                <label className='text-[10px] font-black text-gray-400 uppercase mb-1 block'>Per User Limit</label>
                                <input type='number' name='perUserLimit' value={data.perUserLimit} onChange={handleOnChange} className='w-full p-3 border rounded-xl text-sm outline-none' />
                            </div>
                        </div>
                    </div>

                    {editData && <p className='text-sm text-gray-500'>Used Count: {editData.usedCount || 0}</p>}

                    <div className='flex items-center gap-3 bg-gray-50 p-4 rounded-xl'>
                         <input type='checkbox' name='isActive' checked={data.isActive} onChange={handleOnChange} id='active' className='w-5 h-5 accent-blue-600 cursor-pointer' />
                         <label htmlFor='active' className='text-sm font-bold text-gray-700 cursor-pointer'>Make this coupon live immediately</label>
                    </div>

                    <div className='flex gap-4 pt-4 border-t'>
                        <button type='button' onClick={onClose} className='flex-1 py-3 text-gray-500 font-bold uppercase tracking-wider text-xs border rounded-xl hover:bg-gray-50'>Cancel</button>
                        <button type='submit' className='flex-1 py-3 bg-blue-600 text-white font-bold uppercase tracking-wider text-xs rounded-xl hover:bg-blue-700 shadow-lg transition-all'>
                            {editData ? "Update Coupon" : "Create Coupon"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UploadCoupon;